import { useEffect, useMemo } from 'react';
import { useFormContext } from 'react-hook-form';

import { useGetChangeTaskSubTypeQuery } from '@xemplo/amendment-query';
import { FUTURE_SCHEDULED_PAYRUN } from '@xemplo/gp-constants';
import { ChangeTaskTypes } from '@xemplo/gp-types';
import { useGetPayrunByIdQuery } from '@xemplo/payrun-query';
import { useListBuilder } from '@xemplo/stateful-list-core';
import { V2 } from '@xemplo/text-dropdown';

import { FormFields } from '../../../create-amendment.types';
import * as S from '../../modal.styles';

const changeTaskIdMap: Record<number, string> = {
  1: 'Allowance',
  2: 'Deduction',
  3: 'Salary',
  7: 'Termination',
};

/**
 * TODO: This needs to be revisited. Some funky stuff going on here.
 */
export const SubType = () => {
  const { watch, register, unregister, setValue } = useFormContext<FormFields>();

  const { changeTask, changeTaskSubType, businessUnit, payrun } = watch();

  const isPayInstruction = changeTask === ChangeTaskTypes.PAY_INSTRUCTION;
  const payrunId = !payrun || payrun === FUTURE_SCHEDULED_PAYRUN ? null : payrun;
  const { data: payrunData } = useGetPayrunByIdQuery({ id: payrunId });

  const amendmentTaskTypeName = changeTaskIdMap[changeTask];

  const { data: subType, isLoading } = useGetChangeTaskSubTypeQuery({
    requestParams: {
      q: {
        changeTaskValueId: changeTask ?? null,
        businessUnitId: payrunData?.result?.businessUnitId ?? businessUnit ?? null,
      },
    },
  });

  useEffect(() => {
    const selectedSubType = subType?.find((item) => item.id === changeTaskSubType);
    if (selectedSubType?.templateJson) {
      register('amendmentSummary');
      setValue('amendmentSummary', selectedSubType.templateJson);
    } else {
      unregister('amendmentSummary');
    }
  }, [subType, register, unregister, setValue, changeTaskSubType]);

  const listItems = useMemo(
    () =>
      subType?.map((item) => ({
        key: item.id,
        value: item.name,
      })) ?? [],
    [subType],
  );

  const subTypeList = useListBuilder(listItems);

  if (changeTask === ChangeTaskTypes.PAY_INSTRUCTION) return null;
  return (
    <S.FormLabel>
      {amendmentTaskTypeName ?? 'Sub '} type
      <V2.TextDropdownRhf
        items={subTypeList}
        name="changeTaskSubType"
        placeholder="Select type"
        aria-label="Change task sub type field"
        data-testid="changeTaskSubType"
        disabled={isLoading || !subType?.length}
        searchable
        rules={{
          required: isPayInstruction ? false : 'This field is required',
        }}
      />
    </S.FormLabel>
  );
};
